import { createFileRoute } from '@tanstack/react-router'
import { ContractorAvailabilityPage } from '../features/availability/public-pages'

/** A firm's one-device availability page (#495). Public: the token in the path is the credential. */
export const Route = createFileRoute('/availability/$token')({
  component: function AvailabilityRoute() {
    const { token } = Route.useParams()
    return <ContractorAvailabilityPage token={token} />
  },
})
